import type { ReactNode } from 'react';

/**
 * Barra de decisión (rediseño Tech Premium, principio 2): el ÚNICO lugar donde van los
 * botones sólidos de color fuerte — los que mueven el claim de etapa.
 * Uso: <DecisionBar label={t('…')}><button className="btn solid-good">…</button>…</DecisionBar>
 * Clases de botón: .btn.solid-good / .solid-blue / .solid-bad / .solid-warn (styles.css).
 */
export function DecisionBar({
  label,
  hint,
  children,
}: {
  /** Rótulo corto a la izquierda (ej. "Decision"). Siempre vía i18n. */
  label?: ReactNode;
  /** Aclaración chica debajo de los botones (ocupa el ancho completo). */
  hint?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="decision-bar">
      {label != null && <span className="dbar-label">{label}</span>}
      {children}
      {hint != null && <div className="dbar-hint">{hint}</div>}
    </div>
  );
}
